import React from 'react';

import Slider from './Slider';

const Inicio = () => {
  return <Slider />;
};

export default Inicio;
